import { NavLink } from "react-router";

const TransactionsApp = () => {
  return (
    <div>
      <h1>Transactions App</h1>
      <NavLink to="/dashboard">To Dashboard</NavLink>
    </div>
  );
};

export default TransactionsApp;
